import { Box, Divider, Stack } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzMuiButton from "src/components/core-components/mui/buttons/ByzMuiButton";
import PageThreeColumns from "./page_three_columns";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

function PageThree() {
  const { t } = useTranslate();
  
  const muscleToneOptions = [
    { value: "1", label: "Normal" },
    { value: "2", label: "Sedatize" },
    { value: "3", label: "Hipoaktif" },
    { value: "4", label: "Hiperaktif" }
  ];

  const cryingOptions = [
    { value: "1", label: "Yok" },
    { value: "2", label: "Tiz" },
    { value: "3", label: "Canlı" }
  ];
  
  return (
    <>
      <Box p={2}>
        <Grid container spacing={2} sx={{ padding: "0px" }}>
          <Box
            sx={{
              border: "1px solid #DBDBDB",
              borderRadius: "4px",
              padding: "20px",
              width: "100%",
            }}
          >
            <Grid
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t(
                  "newborn-patient-assessment.medical-allergy-surgical-family-history"
                )}
              </ByzMuiTypography>
            </Grid>

            <Grid
              mt={1}
              sx={{
                backgroundColor: "#63B4FF33",
                color: "#2979C3",
                borderRadius: "10px",
              }}
            >
              <ByzMuiTypography isTitle paddingTop={"5px"}>
                {t(
                  "newborn-patient-assessment.neuromuscular-features"
                )}
              </ByzMuiTypography>
            </Grid>

            <Grid container spacing={2} pt={2}>
              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                  title={t("newborn-patient-assessment.muscle-tone")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={muscleToneOptions}
                    label="label"
                    placeholder={t("open-process-menu.select")}
                    sx={{ pt: 1 }}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.moro-reflex")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.sucking-reflex")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.rooting-reflex")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.grasp-reflex")}
                >
                  <ByzMuiRadioButton
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={2} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px" justifyContent="none"
                  title={t("newborn-patient-assessment.crying")}
                >
                  <ByzMuiSelect
                    renderInput={(params) => (
                      <ByzMuiTextField {...params} />
                    )}
                    options={cryingOptions}
                    label= "label"
                    placeholder={t("open-process-menu.select")}
                    sx={{ pt: 1 }}
                    multiple = {false}
                  />
                </ByzTitleAndInputBox>
              </Grid>

              <Grid md={3} xs={6}>
                <ByzTitleAndInputBox marginLeft="0px"
                  title={t("newborn-patient-assessment.general-condition")}
                >
                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.active,newborn-patient-assessment.sleepy"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                </ByzTitleAndInputBox>
              </Grid>
              <Grid
                mt={1}
                md={12} xs={12}
                sx={{
                  backgroundColor: "#63B4FF33",
                  color: "#2979C3",
                  borderRadius: "10px",
                }}
              >
                <ByzMuiTypography isTitle paddingTop={"5px"}>
                  {t(
                    "newborn-patient-assessment.allergy-bracelet"
                  )}
                </ByzMuiTypography>
              </Grid>
                  
              <Grid md={3} xs={6} pt={2}>

                  <ByzMuiRadioButton
                    typographyText="newborn-patient-assessment.allergy-bracelet-available,newborn-patient-assessment.allergy-bracelet-not-available"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
              </Grid>
            </Grid>

            <Divider
              sx={{
                borderColor: "black",
                borderBottomWidth: "2px",
                my: 2,
              }}
            />
            <Box
              sx={{
                border: "1px solid #DBDBDB",
                borderRadius: "4px",
                padding: "20px",
              }}
            >
              <Stack direction={"row"} sx={{ paddingTop: "10px", flexWrap: "wrap", gap: "10px" }}>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Alerjiler")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.allergies")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Alışkanlıklar")}
                    marginLeft={"0px"}
                    sx={{
                      borderRadius: "20px",
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                    }}
                  >
                    {t("newborn-patient-assessment.habits")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Soy Geçmiş")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.family-history")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Geçirilmiş Hastalıklar")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.past-illnesses")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Hastalıklar")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.diseases")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Geçirilmiş Ameliyatlar")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.past-surgeries")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Özel Notlar")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.special-notes")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Nadir Hastalıklar")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.rare-diseases")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                  <ByzMuiButton
                    onClick={() => console.log("Tansiyon Takibi")}
                    marginLeft={"0px"}
                    sx={{
                      backgroundColor: "#63B4FF33",
                      color: "#2979C3",
                      border: "1px solid #2979C3",
                      width: "100%",
                      height: "30px",
                      borderRadius: "20px",
                    }}
                  >
                    {t("newborn-patient-assessment.blood-pressure-monitoring")}
                  </ByzMuiButton>
                </Grid>
                <Grid md={1.75} xs={2}>
                 <ByzMuiButton
                   onClick={() => console.log("Maruziyetler")}
                   marginLeft={"0px"}
                   sx={{
                     backgroundColor: "#63B4FF33",
                     color: "#2979C3",
                     border: "1px solid #2979C3",
                     width: "100%",
                     height: "30px",
                     borderRadius: "20px",
                   }}
                 >
                   {t("newborn-patient-assessment.exposures")}
                 </ByzMuiButton>
               </Grid>
               <Grid md={1.75} xs={2}>
                 <ByzMuiButton
                   onClick={() => console.log("Kullandığı İlaçlar")}
                   marginLeft={"0px"}
                   sx={{
                     backgroundColor: "#63B4FF33",
                     color: "#2979C3",
                     border: "1px solid #2979C3",
                     width: "100%",
                     height: "30px",
                     borderRadius: "20px",
                   }}
                 >
                   {t("newborn-patient-assessment.current-medications")}
                 </ByzMuiButton>
               </Grid>
             </Stack>
           </Box>
         </Box>
         <PageThreeColumns />
       </Grid>
     </Box>
   </>
 );
}

export default PageThree;